const AzerbaijanSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_110815)">
      <path
        d="M40 19.9989C40 17.5525 39.56 15.209 38.756 13.0425L20 12.1729L1.24398 13.0424C0.440078 15.209 0 17.5525 0 19.9989C0 22.4454 0.440078 24.7889 1.24398 26.9554L20 27.825L38.756 26.9555C39.56 24.7889 40 22.4454 40 19.9989Z"
        fill="#D80027"
      />
      <path
        d="M19.9997 40.0005C28.599 40.0005 35.9298 34.573 38.7557 26.957H1.24365C4.06951 34.573 11.4004 40.0005 19.9997 40.0005Z"
        fill="#6DA544"
      />
      <path
        d="M1.24365 13.0435H38.7558C35.9298 5.4275 28.599 0 19.9997 0C11.4004 0 4.06951 5.4275 1.24365 13.0435Z"
        fill="#338AF3"
      />
      <path
        d="M20.4346 25.6517C17.313 25.6517 14.7824 23.1211 14.7824 19.9995C14.7824 16.878 17.313 14.3473 20.4346 14.3473C21.4079 14.3473 22.3237 14.5934 23.1233 15.0267C21.8689 13.8001 20.1536 13.043 18.2607 13.043C14.4187 13.043 11.3042 16.1575 11.3042 19.9995C11.3042 23.8414 14.4187 26.9559 18.2607 26.9559C20.1537 26.9559 21.869 26.1988 23.1233 24.9722C22.3237 25.4056 21.4079 25.6517 20.4346 25.6517Z"
        fill="#F0F0F0"
      />
      <path
        d="M24.7822 16.0869L25.5309 18.1925L27.5491 17.2329L26.5897 19.2512L28.6952 20L26.5897 20.7487L27.5491 22.767L25.5309 21.8075L24.7822 23.913L24.0336 21.8075L22.0152 22.767L22.9748 20.7487L20.8691 20L22.9748 19.2512L22.0152 17.2329L24.0336 18.1925L24.7822 16.0869Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110815">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default AzerbaijanSvg;
